import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {COLOURS} from "./Colours";
import {Style} from "ol/style";

export class HumpsLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = LayerDefBase.buildStyle(5, COLOURS.HUMP.VISITED);
    private unvisitedStyle = LayerDefBase.buildStyle(5, COLOURS.HUMP.UNVISITED);

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getLayerHills(hillLists: HillLists): Hill[] {
        const combined = [
            ...hillLists.others,
            ...this.removeWainwrights(hillLists.lakes),
        ];
        return combined
            .filter((h) => h.categories.includes("HUMP"))
            .filter((h) => !h.categories.includes("MARILYN"));
    }

    setupGPX() {
        const elem = document.getElementById("gpx_hump");
        this.setGPXClickListener(elem, "humps.gpx");
    }

    getName(): string {
        return "Humps";
    }
}
